import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    overflowY: 'auto',
    padding: '18px 40px 0',
    margin: '-18px 0 0',
    height: 'calc(100% - 125px)',
    ['@media (max-width:1010px)']: {
      padding: '18px 0 0 40px',
      height: 'calc(100% - 125px)'
    },
    ['@media (max-width:850px)']: {
      padding: '0 0 0 40px',
      margin: '0px',
      height: 'calc(100% - 64px)'
    },
    ['@media (max-width:600px)']: {
      padding: '0 0 0 15px',
      height: 'calc(100% - 102px)'
    }
  },
  leftSide: {
    width: '100%',
    padding: '0 40px 0 1px',
    ['@media (max-width:1010px)']: {
      paddingRight: '40px'
    },
    ['@media (max-width:850px)']: {
      marginTop: 0
    },
    ['@media (max-width:600px)']: {
      paddingRight: '15px',
      marginTop: 0
    }
  },
  rightSide: {
    width: '300px',
    minWidth: '300px',
    ['@media (max-width:1010px)']: {
      display: 'none'
    }
  },
  sectionTitleIndent: {
    marginBottom: '20px',
    textTransform: 'uppercase',
    letterSpacing: '0.05em'
  },
  accommodationCheckout: {
    marginBottom: '15px',
    border: '1px solid #E2EBF6',
    padding: '10px 15px 0',
    borderRadius: '3px'
  },
  checkoutInfo: {
    marginBottom: '10px'
  },
  generalRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '5px'
  },
  listTitle: {
    color: 'black',
    textTransform: 'uppercase',
    letterSpacing: '0.035em',
    marginBottom: '10px'
  },
  participantRow: {
    borderBottom: '1px solid #E2EBF6',
    marginBottom: '6px',
    paddingBottom: '4px',
    '&:last-child': {
      border: 0
    }
  },
  bookingColumn: {
    flex: '1 1 30%',
    '&:nth-child(2)': {
      textAlign: 'center'
    },
    '&:last-child': {
      textAlign: 'end'
    }
  },
  totalRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 15px',
    marginBottom: '15px',
    borderRadius: '3px',
    overflow: 'hidden',
    position: 'relative',
    '&:after': {
      position: 'absolute',
      display: 'block',
      content: '""',
      height: '100%',
      width: '100%',
      left: 0,
      top: 0,
      background: theme.baseUI.color,
      opacity: '.1'
    }
  },
  summaryTitle: {
    marginBottom: '15px'
  },
  currency: {
    fontSize: '10px'
  },
  bookingTitle: {
    color: theme.baseUI.color
  },
  deleteIcon: {
    fontSize: '15px',
    cursor: 'pointer'
  }
}));

export default useStyles;
